import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconScale = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-scale"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={clsxm('size-5 text-black', className)}
    {...props}
  >
    <path
      d="M10 1V3M18.86 2.44L11 3.83M9 4.17L1.14 5.56M19 14L16 3L13 14M7 15L4 5.06L1 15M10 3C9.80222 3 9.60888 3.05865 9.44443 3.16853C9.27998 3.27841 9.15181 3.43459 9.07612 3.61732C9.00043 3.80004 8.98063 4.00111 9.01921 4.19509C9.0578 4.38907 9.15304 4.56725 9.29289 4.70711C9.43275 4.84696 9.61093 4.9422 9.80491 4.98079C9.99889 5.01937 10.2 4.99957 10.3827 4.92388C10.5654 4.84819 10.7216 4.72002 10.8315 4.55557C10.9414 4.39112 11 4.19778 11 4C11 3.73478 10.8946 3.48043 10.7071 3.29289C10.5196 3.10536 10.2652 3 10 3ZM19 15V14H13V15C13 15.7956 13.3161 16.5587 13.8787 17.1213C14.4413 17.6839 15.2044 18 16 18C16.7956 18 17.5587 17.6839 18.1213 17.1213C18.6839 16.5587 19 15.7956 19 15ZM4 19C4.79565 19 5.55871 18.6839 6.12132 18.1213C6.68393 17.5587 7 16.7956 7 16V15H1V16C1 16.7956 1.31607 17.5587 1.87868 18.1213C2.44129 18.6839 3.20435 19 4 19Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
